import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'underscore';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { Endpoint, HelpIndex, EntityType, SearchType } from '../../../models/enums';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { Comparison } from '../../../models/comparison';
import { Permissions, ObjectActionListType } from '../../../models/permission';
import { ViewType } from '../../../models/view';
import { Task, TaskType } from '../../../models/task';
import { DocumentListColumnInfo } from '../../document-list/document-list-info/document-list-column-info';
import { CellTemplateType, FilterTemplateType, GenericColDef, GridContext, GridRowSelectionType } from '../../../models/grid-context';
import { DrRequestInfo } from '../../../models/dr-request-info';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';
import { RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { MetadataService } from '../../../services/metadata/metadata.service';
import { isNullOrUndefined } from '../../../models/utils';
@Component({
    standalone: false,
    selector: 'res-create-manifest',
    templateUrl: './create-manifest.component.html',
    styleUrls: ['./create-manifest.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CreateManifestModalComponent extends BaseModalComponent implements OnInit {
    @ViewChild(GenericGridComponent, { static: true }) genericGrid: GenericGridComponent;

    modalTitle = 'Create Manifest';
    modalTitleSecondPart = '';
    modalClass = 'create-manifest';
    autoId = 'create-manifest';
    primaryButtonLabel = 'Create Manifest';
    secondaryButtonLabel = 'Cancel';
    verifyRequiredValidator = true;
    fields = 'currentColumns';
    fileExtension = '.csv';
    filename = '';
    destination = 'download';
    dataAreas: Array<any>;
    orgTemplates: Array<any> = [];
    sysTemplates: Array<any> = [];
    selectedTemplate = 'current';
    selectedDataArea: string;
    modalHelpIndex = HelpIndex.create_manifest_dlg;
    isBusy = false;
    isBusyMessage = '';
    hasConnAccessPermissions: boolean;
    projectHandle: string;
    columnsText = 'Current Doc List Columns';
    hideUnchecked = false;
    gridName = 'Create Manifest Metadata';
    rowsSelected: Array<any> = [];
    metadataTemplateFields: Array<any> = [];
    allMetadataFields: Array<any> = [];
    descriptions: Array<any>;
    filterQuery = '';
    initialSelectedRows: Array<any> = [];
    isFiltering: boolean;
    allRowsSelected: boolean;

    constructor(
        private modalService: BsModalService,
        private modalRef: BsModalRef,
        private restService: RestService,
        private commonService: CommonService,
        private metadataService: MetadataService,
        public changeDetector: ChangeDetectorRef) {
        super(modalService, modalRef);
    }

    requestInfo = new DrRequestInfo({
        endpoint: Endpoint.realmManager_getAllFieldsDocumentMetadataTemplate,
        responseName: 'metadataFolders',
    });

    rowSelection = GridRowSelectionType.multipleCheckboxWithRowClickSelection;

    columnDefs = new Array<GenericColDef>(
        {
            colId: 'checkbox',
            automationId: this.autoId,
            minWidth: 36, maxWidth: 36, width: 36,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            suppressSizeToFit: true,
        },
        {
            headerName: 'Field Name',
            field: 'name',
            automationId: this.autoId,
            lockVisible: true,
            width: 230,
            filterType: FilterTemplateType.freeform,
            defaultSortBy: 'name',
            defaultSortAscending: true,
        },
        {
            headerName: 'Description',
            field: 'description',
            automationId: this.autoId,
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
        }
    );

    gridContext = new GridContext({
        inlineGridFilter: true,
        sortTypeEnabled: false,
        sortEnabled: false,
        sortAscending: true,
        sortBy: 'name',
        onFilterApply: (passwordName: string) => this.onFilterApply(passwordName),
    });

    isSystemUser = false;

    ngOnInit(): void {
        this.isBusyMessage = 'Loading ...';
        this.isBusy = true;
        this.hasConnAccessPermissions = Permissions.checkUserPermission(ObjectActionListType.CONNECTOR_ACCESS);
        this.projectHandle = this.commonService.currentProject.handle;
        if (!this.modalData.defaultColumns || this.modalData.defaultColumns.length === 0) {
            this.columnsText = 'Default Doc List Columns';
            this.modalData.defaultColumns = this.getDefaultColumnsByView();
        }
        this.isSystemUser = this.commonService.currentUser?.importedFromSystemUser || this.commonService.currentUser?.originalCustomerName === 'super_system_customer';
        this.loadDataAreas();
        this.loadTemplates();
        if (this.genericGrid) {
            this.allRowsSelected = this.genericGrid.allRowsSelected;
            this.loadData(this.commonService.currentProject.handle, true);
        }
        this.modalTitle = 'Create Manifest for ' + (this.modalData.entity?.name ?
            this.modalData.entity.name.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : this.modalData.entity.description.replace(/&lt;/g, '<').replace(/&gt;/g, '>')) + ' ';
        this.modalTitleSecondPart = '(' + (this.modalData.entity.documentCount ? this.modalData.entity.documentCount : this.modalData.entity.numberResults) + ' documents)';
    }

    loadData(handle, defaultLoad): void {
        this.isBusy = true;
        this.isBusyMessage = 'Loading Fields...';
        this.metadataTemplateFields = [];
        this.allMetadataFields = [];
        this.metadataService.fieldDescriptions().then(responseDescriptions => {
            this.descriptions = responseDescriptions ? responseDescriptions : [];
            const isSystemTemplate = handle !== this.commonService.currentProject?.handle && (this.sysTemplates?.length > 0 && !isNullOrUndefined(this.sysTemplates.find(t => t.handle === handle)));
            this.restService.post(Endpoint.projectManager_getDocumentMetadataTemplate, { handle: handle, systemScope: this.isSystemUser && isSystemTemplate }).then(responseProfile => {
                if (responseProfile && responseProfile.metadataFolders) {
                    responseProfile.metadataFolders.forEach(folder => {
                        if (folder.handle && folder.fields) {
                            folder.fields.forEach(element => {
                                this.metadataTemplateFields.push({
                                    name: element,
                                    description: this.getDescriptionByColumnName(element),
                                });
                            });
                        }
                    });
                }
                this.restService.post(Endpoint.realmManager_getAllFieldsDocumentMetadataTemplate, { containerId: handle, systemScope: this.isSystemUser && isSystemTemplate }).then(responseAllFields => {
                    if (responseAllFields && responseAllFields.metadataFolders) {
                        responseAllFields.metadataFolders.forEach(folder => {
                            if (folder.handle && folder.fields) {
                                folder.fields.forEach(element => {
                                    this.allMetadataFields.push({
                                        name: element,
                                        description: this.getDescriptionByColumnName(element),
                                    });
                                });
                            }
                        });
                        if (defaultLoad) {
                            this.setDocListFields();
                        } else {
                            this.selectRows(this.allMetadataFields, this.metadataTemplateFields);
                        }
                    }
                    this.isBusy = false;
                }, error => {
                    this.isBusy = false;
                });
            }, error => {
                this.isBusy = false;
            });
        }, error => {
            this.isBusy = false;
        });
    }

    getDescriptionByColumnName(colName: string): string {
        if (this.descriptions?.length > 0 && colName) {
            const desc = this.descriptions.find(d => d.name === colName);
            return desc?.value ? desc.value : '';
        }
        return '';
    }

    loadDataAreas(): void {
        if (this.hasConnAccessPermissions) {
            this.restService.post(Endpoint.orgManager_listExportDataAreas, {}).then(response => {
                if (response && response.exportDataAreas) {
                    this.dataAreas = response.exportDataAreas;
                } else {
                    this.dataAreas = [];
                }
            }, error => {
                this.isBusy = false;
                this.commonService.openErrorModal('Retrieval of export data areas has failed.');
            });
        }
    }

    loadTemplates(): void {
        const hasOrgTemplatesPerm = Permissions.checkUserPermission(ObjectActionListType.ORG_METADATA_VIEW_FIELDS);
        const hasSysTemplatesPerm = this.isSystemUser && Permissions.checkUserPermission(ObjectActionListType.SYSTEM_METADATA_VIEW_FIELDS);

        if (hasSysTemplatesPerm || hasOrgTemplatesPerm) {
            const singleScope = hasSysTemplatesPerm ? 'SYSTEM_LEVEL' : 'ORG_LEVEL';
            this.restService.post(Endpoint.orgManager_listTemplates, {
                scope: hasSysTemplatesPerm && hasOrgTemplatesPerm ? 'SYSTEM_AND_ORG' : singleScope,
                tempType: 'DOCUMENT_METADATA',
                systemScope: hasSysTemplatesPerm
            }).then(response => {
                if (response && response.templates) {
                    const templateGroups = _.partition(response.templates, (template) => template.orgId === 'DRSystem');
                    this.sysTemplates = templateGroups[0];
                    this.orgTemplates = templateGroups[1];
                }
                this.selectedTemplate = "Select from Template:";
            }, error => {
                this.isBusy = false;
                this.commonService.openErrorModal('Retrieval of templates has failed.');
            });
        } else {
            this.isBusy = false;
        }
    }

    isPrimaryButtonEnabled(): boolean {
        return (this.destination === 'download' || this.filename.trim().length > 0) && (this.isFiltering ? this.initialSelectedRows.map(meta => meta.name).length > 0 : this.genericGrid.selectedRows.map(meta => meta.name).length > 0);
    }

    createManifest(): void {
        this.isBusyMessage = 'Creating Manifest ...';
        this.isBusy = true;
        const fieldsToSend = this.isFiltering ? this.initialSelectedRows.map(meta => meta.name) : this.genericGrid.selectedRows.map(meta => meta.name);
        const scoreField = this.modalData.defaultColumns.find(d => d === 'score');
        if (scoreField) {
            fieldsToSend.push(scoreField);
        }
        const attachmentCount = this.modalData.defaultColumns.find(d => d === 'attachmentCount');
        if (attachmentCount) {
            fieldsToSend.push(attachmentCount);
        }
        const isAttachment = this.modalData.defaultColumns.find(d => d === 'isAttachment');
        if (isAttachment) {
            fieldsToSend.push(isAttachment);
        }

        if (this.destination === 'server') {
            this.restService.post(Endpoint.viewManager_exportManifest, {
                sourceViewHandle: this.modalData.entity instanceof Comparison ? this.modalData.entity.docListHandle : this.modalData.entity.handle,
                manifestFormat: this.fileExtension === '.csv' ? 'CSV' : 'XML',
                targetPath: this.filename,
                targetDataAreaHandle: this.selectedDataArea,
                taskDescription: 'Export view manifest',
                selectedAttributes: fieldsToSend,
                viewManifestTemplate: this.fields === 'fromTemplate' ? this.selectedTemplate : null
            }, true, true).then(response => {
                this.isBusy = false;
                this.commonService.openInformationToastNotification('Manifest creation has started. Once finished, the manifest can be found at the selected Export Data Area.');
                this.closeModal(true);
            }, error => {
                this.isBusy = false;
                this.commonService.openErrorModal('Manifest creation has failed.');
            });
        } else {
            // this flag is to check if the task is a Data Set(Creating Representation Analytic Index for <dsname>)
            const isDataSetFromWB = this.modalData.entity instanceof Task && this.modalData.entity.task === 'DOCUMENT_ADD_FROM_FILE_LIST';
            let dataSetSourceViewHandle: string;
            if (isDataSetFromWB) {
                // the sourceViewHandle for a data set from work basket is received in the attributes from backend
                const dsProjectHandle = _.findWhere((this.modalData.entity as Task).attributes, { name: 'projecthandle' });
                const dsCorpusHandle = _.findWhere((this.modalData.entity as Task).attributes, { name: 'corpusHandle' });
                dataSetSourceViewHandle = dsProjectHandle && dsCorpusHandle ? dsProjectHandle.value + ':' + dsCorpusHandle.value : '';
            }
            const index = this.modalData.defaultColumns.indexOf('displayName');
            if (this.modalData.entity instanceof Task && index !== -1) {
                this.modalData.defaultColumns[index] = 'filename';
            }
            this.restService.post(Endpoint.viewManager_retrieveManifest, {
                manifestFormat: this.fileExtension === '.csv' ? 'CSV' : 'XML',
                selectedAttributes: fieldsToSend,
                sourceViewHandle: isDataSetFromWB ? dataSetSourceViewHandle : this.modalData.entity instanceof Comparison ? this.modalData.entity.docListHandle : this.modalData.entity.handle,
                taskDescription: 'Downloading manifest file',
                viewManifestTemplate: this.fields === 'fromTemplate' ? this.selectedTemplate : null
            }, true, true).then(response => {
                this.isBusy = false;
                this.commonService.openInformationToastNotification('Manifest creation has started. Once finished, the manifest can be downloaded from the Work Basket.');
                this.closeModal(true);
            }, error => {
                this.isBusy = false;
            });
        }
    }

    getDefaultColumnsByView() { // Use the grid's default viewed columns for this view type as the default columns to use in the manifest
        let columns = [];
        let nodeEntityType: EntityType;
        if (this.modalData.entity.task === SearchType.VECTOR_SET_FIND_DUPLICATES) {
            nodeEntityType = EntityType.exactOrContentDuplicatesSearchResult;
        } else if (this.modalData.entity.viewType === ViewType.CORPUS_RESULT || this.modalData.entity.viewType === ViewType.CORPUS_SET_RESULT) {
            nodeEntityType = EntityType.searchResultImport;
        } else if (this.modalData.entity.viewType === ViewType.WORKING_SET_RESULT &&
            (this.modalData.entity.task === SearchType.COLLECTION_SIMILARITY || this.modalData.entity.taskType === TaskType.NEAR_DUPE
                || this.modalData.entity.taskType === TaskType.SEARCH_BY_PROFILE)) {
            nodeEntityType = EntityType.similaritySearchResult;
        } else if ((this.modalData.entityType === EntityType.searchResult || this.modalData.entity.task === 'VECTOR_SET_SEARCH') && this.modalData.entity.attributes && this.modalData.entity.attributes.find(a => a.name === 'sampleSetResult')) {
            nodeEntityType = EntityType.sampleSet;
        } else if (this.modalData.entity as Task && this.modalData.entity.task === 'DOCUMENT_ADD_FROM_FILE_LIST') {
            nodeEntityType = EntityType.import;
        } else if (this.modalData.entity as Task && (this.modalData.entity.taskType === TaskType.COMPARE_EXPORT
            || this.modalData.entity.task === 'VECTOR_SET_SEARCH' || this.modalData.entity.task === 'DYNAMIC_FOLDER_RULES' || this.modalData.entity.task === 'METADATA_BULK_SEARCH')) {
            nodeEntityType = EntityType.searchResult;
        } else if (this.modalData.entity.viewType === ViewType.WORKING_SET_RESULT && this.modalData.entity.task === SearchType.DOCUMENT_FIND_DUPLICATES) {
            nodeEntityType = EntityType.searchResult;
        } else {
            nodeEntityType = this.modalData.entityType;
            if (nodeEntityType === EntityType.custodian || nodeEntityType === EntityType.tagView || nodeEntityType === EntityType.mediaID || nodeEntityType === EntityType.batch ||
                nodeEntityType === EntityType.folder) {  // These substitutions are based on the columns defined in DocumentListInfo.
                nodeEntityType = EntityType.projectData;
            }
        }
        columns = _.map(_.reject(DocumentListColumnInfo.get(nodeEntityType), column => {
            return column.checkboxSelection || column.field === 'tagList' || column.cellTemplateType === 'contextMenu' ||
                column.cellTemplateType === 'docListFamilyThread' || column.hide;
        }), column => column.field);
        return columns;
    }

    onChange() {
        if (this.hideUnchecked) {
            const rows = [];
            const selectedRows = this.genericGrid.gridApi.getSelectedRows();
            this.allMetadataFields.forEach(row => {
                selectedRows.forEach((node) => {
                    if (row.name === node.name)
                        rows.push(node)
                });
            });
            this.selectRows(rows, selectedRows);
        } else {
            if (this.filterQuery) {
                this.onFilterApply(this.filterQuery);
                this.selectRows(this.genericGrid.getData(), this.genericGrid.gridApi.getSelectedRows());
            } else {
                this.selectRows(this.allMetadataFields, this.genericGrid.gridApi.getSelectedRows());
            }
        }
    }

    selectRows(rows: Array<any>, preSelectedRows: Array<any>): void {
        this.genericGrid.isBusy = true;
        this.genericGrid.gridApi.deselectAll();
        this.rowsSelected = [];
        this.genericGrid.setData([]);

        let preSelectedRowsWithoutUiFields = null; // ui fields: displayed in UI but not present in the metadata fields list returned by the api e.g. 'score' field 
        if (this.hideUnchecked && preSelectedRows?.length > 0) {
            preSelectedRowsWithoutUiFields = [];
            this.allMetadataFields.forEach(metadataField => {
                const preSelField = preSelectedRows.find(field => field.name === metadataField.name);
                if (preSelField) {
                    preSelectedRowsWithoutUiFields.push(preSelField);
                }
            });
        }
        this.genericGrid.setData(this.hideUnchecked ? (this.filterQuery !== '' ? rows : preSelectedRowsWithoutUiFields) : rows);

        if (rows.length === preSelectedRows.length && preSelectedRows.length === this.allMetadataFields.length) {
            this.genericGrid.gridApi.selectAll();
        } else {
            preSelectedRows.forEach(row => {
                this.genericGrid.findNode((node: RowNode) => node.data.name === row.name, true);
            });
        }

        const firstNode = this.genericGrid.gridApi.getRowNode('0');
        this.genericGrid.gridApi?.ensureNodeVisible(firstNode);
        this.areAllRowsSelected();
        this.genericGrid.isBusy = false;
        this.changeDetector.detectChanges();
    }

    onSelectionChanged = (event?: SelectionChangedEvent) => {
        if (event && event.api && this.genericGrid.gridApi) {
            this.rowsSelected = this.genericGrid.selectedRows;
        }
        this.areAllRowsSelected();
    }

    areAllRowsSelected(): void {
        const selectedRows = this.genericGrid.gridApi.getSelectedRows().filter(row => !row.isDisabled);
        this.allRowsSelected = (selectedRows.length > 0 && selectedRows.length === this.genericGrid.gridApi.getDisplayedRowCount() && this.genericGrid.gridApi.getDisplayedRowCount() === this.allMetadataFields.length);
    }

    onSelectedTemplateChanged(): void {
        this.rowsSelected = null;
        this.loadData(this.selectedTemplate, false);
    }

    setDocListFields(): void {
        this.selectedTemplate = 'Select from Template:';
        const docListFields = [];
        this.modalData.defaultColumns.forEach(element => {
            switch (element) {
                case 'date_or_lastmodifiedtime': {
                    docListFields.push({
                        name: 'date',
                        description: this.getDescriptionByColumnName('date'),
                    });
                    docListFields.push({
                        name: 'lastmodifiedtime',
                        description: this.getDescriptionByColumnName('lastmodifiedtime'),
                    });
                    break;
                }
                case 'displayName': {
                    docListFields.push({
                        name: 'filename',
                        description: this.getDescriptionByColumnName('filename'),
                    });
                    break;
                }
                default: {
                    docListFields.push({
                        name: element,
                        description: this.getDescriptionByColumnName(element),
                    });
                    break;
                }
            }
        });
        this.selectRows(this.allMetadataFields, docListFields);
    }

    onFilterApply(queryStr: string): void {
        this.filterQuery = queryStr;
        let availableFields = [];
        if (!queryStr || queryStr === '') {
            availableFields = this.allMetadataFields;

            this.filterResultList();

            setTimeout(() => {
                this.genericGrid.setData(this.allMetadataFields);
                this.selectRows(this.allMetadataFields, this.initialSelectedRows);
                this.isFiltering = false;
            });
        } else {
            availableFields = _.filter(this.hideUnchecked ? this.rowsSelected : this.allMetadataFields, (field) =>
                field.name.toLowerCase().indexOf(queryStr.toLowerCase()) !== -1);

            if (!this.isFiltering) {
                this.initialSelectedRows = this.rowsSelected.map(a => Object.assign({}, a));
                this.isFiltering = true;
            }
            this.genericGrid.setData(availableFields);
            this.selectRows(availableFields, this.rowsSelected);
        }
    }

    filterResultList(): void {
        let availableFields = [];
        this.rowsSelected.forEach(element => {
            availableFields = _.filter(this.initialSelectedRows, (field) =>
                field.name === element.name);
            if (availableFields.length === 0) {
                this.initialSelectedRows.push(element);
            }
        });
        this.genericGrid.getData().forEach(element => {
            availableFields = _.filter(this.rowsSelected, (field) =>
                field.name === element.name);
            if (availableFields.length === 0) {
                const itemInList = _.filter(this.initialSelectedRows, (field) => field.name === element.name);
                if (itemInList?.length > 0) {
                    this.initialSelectedRows.splice(this.initialSelectedRows.findIndex(item => item.name === element.name), 1);
                }
            }
        });
    }
}